import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const FooterCopyrightBar = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <div id='footer-bottom-bar' className='text-center text-xs bg-[#1a658f] p-2'>
            <p className="text-gray-100"><FormattedMessage id='footer.copyright' defaultMessage="© Copyright" /> {currentYear}, <a href='https://www.ucar.edu' className='font-bold text-white'>The University Corporation for Atmospheric Research</a>. <FormattedMessage id='footer.all_rights_reserved' defaultMessage="All Rights Reserved" />. <Link to="/legal" className='font-bold text-white'><FormattedMessage id='footer.legal_notices' defaultMessage="Legal Notices"/></Link> | <Link to="https://www.ucar.edu/web-accessibility" className='font-bold text-white'><FormattedMessage id='footer.accessibility' defaultMessage="Accessibility"/></Link>.</p>
        </div>
    );
};

export default FooterCopyrightBar;